import { ref } from 'vue';
import client from '@/client/index';
export function useUploadResource(target) {
    var resource = ref('');
    var uploading = ref(false);
    var errors = ref({});
    var message = ref('');
    var upload = function (callback) {
        var headers = { "Content-Type": "multipart/form-data" };
        var payload = new FormData();
        payload.append("upload", resource.value);
        uploading.value = true;
        client.post(target.value, payload, { headers: headers })
            .then(function (result) {
            resource.value = '';
            uploading.value = false;
            message.value = '';
            errors.value = {};
            callback();
        })
            .catch(function (error) {
            message.value = error.response.data.message;
            errors.value = error.response.data.errors;
            resource.value = '';
            uploading.value = false;
        });
    };
    return { resource: resource, upload: upload, uploading: uploading, message: message, errors: errors };
}
;
